import { ActionTypes } from '../constants/AppConstants';
import AppDispatcher from '../dispatcher/AppDispatcher';

const LayoutActions = {
    setEmbedded(isEmbedded) {
        if (!window.ReactNativeWebView) {
            AppDispatcher.dispatch({
                actionType: ActionTypes.LAYOUT_SET_EMBEDDED,
                isEmbedded: false
            });
        } else {
            AppDispatcher.dispatch({
                actionType: ActionTypes.LAYOUT_SET_EMBEDDED,
                isEmbedded
            });
        }
    }
};

export default LayoutActions;
